import type { HistoricalDataPeriodInterval } from 'models/historical_data';

export const eventForecastHistoryKeys = {
    all: ['eventForecastHistory'] as const,
    byEvent: (seriesTicker: string, eventTicker: string, startTs: number, endTs: number, periodInterval: string) =>
        [...eventForecastHistoryKeys.all, seriesTicker, eventTicker, startTs, endTs, periodInterval] as const,
};

export const marketCandlestickHistoryKeys = {
    all: ['marketCandlestickHistory'] as const,
    /** Keep the two consumer result shapes from colliding in the React Query cache. */
    byMarket: (
        shape: 'statsOnly' | 'chart',
        seriesTicker: string,
        marketId: string,
        startTs: number,
        endTs: number,
        periodInterval: HistoricalDataPeriodInterval,
    ) => [...marketCandlestickHistoryKeys.all, shape, seriesTicker, marketId, startTs, endTs, periodInterval] as const,
};
